import { combineReducers } from "redux";
import assessmentsReducer from "./Assessments/state/assessmentsReducer";
import emailsReducer from "./Communications/Emails/state/reducers/emailsReducer";
import messagesReducer from "./Communications/Messages/state/reducers/messagesReducer";
import { EmbeddedVideosReducer } from "./EmbeddedVideos/state/reducer";
import { SCORMReducer } from "./SCORM/state/reducer";
import { eventsReducer } from "./Events/state/reducers/eventsReducer";
import flowsReducer from "./Flows/state/flowsReducer";
import pdfsReducer from "./Pdfs/state/pdfsReducer";
import groupsAssignmentReducer from "./PeopleAssignments/state/reducers/groupsAssignmentReducer";
import groupTemplatesAssignmentReducer from "./PeopleAssignments/state/reducers/groupTemplatesAssignmentReducer";
import usersAssignmentReducer from "./PeopleAssignments/state/reducers/usersAssignmentReducer";
import campaignsReducer from "./SimulatedPhishing/Campaigns/state/campaignsReducer";
import surveyReducer from "./Surveys/state/surveyReducer";
import videosReducer from "./Videos/state/videosReducer";
import externalLinksReducer from "./ExternalLinks/state/externalLinksReducer";

const libraryReducer = combineReducers({
  flows: flowsReducer,
  videos: videosReducer,
  embeddedVideos: EmbeddedVideosReducer,
  scorm: SCORMReducer,
  pdfs: pdfsReducer,
  userAssignment: usersAssignmentReducer,
  groupAssignment: groupsAssignmentReducer,
  groupTemplatesAssignment: groupTemplatesAssignmentReducer,
  emails: emailsReducer,
  messages: messagesReducer,
  assessments: assessmentsReducer,
  events: eventsReducer,
  campaigns: campaignsReducer,
  surveys: surveyReducer,
  externalLinks: externalLinksReducer,
});

export type LibraryState = ReturnType<typeof libraryReducer>;

export { libraryReducer };
